"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _clear = _interopRequireDefault(require("../img/clear.svg"));

var _deleteDigit = _interopRequireDefault(require("../img/deleteDigit.svg"));

function _default(palette) {
  return {
    display: 'block',
    color: palette.tInactive,
    fontSize: palette.tsXXLarge,
    lineHeight: palette.tlXXLarge,
    background: 'transparent',
    animationBackgroundColor: palette.elLight,
    animationDisplay: 'block',
    focusColor: palette.tInactive,
    focusBackground: 'transparent',
    hoverColor: palette.tFilled,
    hoverBackground: 'transparent',
    activeColor: palette.tHint,
    activeBackground: 'transparent',
    labelColor: palette.tLabel,
    errorLabelColor: palette.tError,
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    bulletIdleBackground: '#e0e0e0',
    bulletIdleBorderColor: '#e0e0e0',
    bulletFilledBackground: palette.elAccent,
    bulletFilledBorderColor: palette.elAccent,
    clearIcon: _clear["default"],
    deleteIcon: _deleteDigit["default"]
  };
}